export default {
  "hero.eyebrow": "CENTRE DE RESSOURCES DE LA FEUILLE USFANS",
  "hero.title": "Feuille USFans — Trouvez produits, liens et guides d'achat plus intelligents",
  "hero.description": "Explorez la feuille USFans, découvrez des liens produits utiles, comparez les catégories, comprenez le contrôle qualité et l'expédition, et prenez de meilleures décisions d'achat grâce à notre centre de ressources indépendant.",
  "hero.trust": "Ressource indépendante • Guides actualisés • Support multilingue",
  "hero.buyNow": "Acheter maintenant",
  "hero.explore": "Découvrir la feuille USFans",

  "dropdown.label": "Choisissez une catégorie",
  "dropdown.placeholder": "Sélectionnez une catégorie pour accéder au site principal",

  "categories.title": "Explorez les catégories de la feuille USFans",
  "categories.description": "Choisissez une catégorie ci-dessous pour ouvrir la section correspondante sur le site principal. Chaque bouton vous mène directement aux produits que vous souhaitez parcourir.",

  "about.title": "Qu'est-ce que la feuille USFans ?",
  "about.p1": "La feuille USFans est une ressource structurée de découverte de produits. Au lieu d'ouvrir des dizaines d'onglets, elle regroupe liens, catégories, images et notes en un seul endroit pour que vous parcouriez, compariez et avanciez plus vite.",
  "about.p2": "Imaginez un seul tableau où chaque ligne est un produit et chaque colonne contient un détail utile : la catégorie, le nom, le lien et des notes. Comme tout est regroupé par catégorie, vous passez facilement des chaussures aux hoodies, t-shirts, vestes et accessoires.",
  "about.p3": "Une bonne feuille vous aide aussi à réfléchir avant d'acheter. Vous pouvez vérifier les photos de contrôle qualité, consulter les détails d'expédition et comparer plusieurs options avant de passer commande.",
  "about.cta": "Découvrez comment fonctionne la feuille USFans",

  "guide.title": "Comment utiliser la feuille",
  "guide.step1.title": "Choisissez une catégorie",
  "guide.step1.desc": "Commencez par la section qui correspond à ce que vous cherchez, des chaussures aux accessoires.",
  "guide.step2.title": "Parcourez et comparez",
  "guide.step2.desc": "Lisez les noms, liens et notes pour présélectionner les produits qui vous conviennent.",
  "guide.step3.title": "Vérifiez les détails",
  "guide.step3.desc": "Consultez le prix, les tailles, les photos QC et l'expédition avant de décider.",
  "guide.step4.title": "Ouvrez le produit",
  "guide.step4.desc": "Cliquez pour accéder au site principal, voir la fiche complète et finaliser votre commande.",

  "cards.title": "Guides et informations USFans",
  "cards.description": "Des guides indépendants et honnêtes pour comprendre la feuille, l'expédition, le contrôle qualité et plus encore avant d'acheter.",
  "card.review.title": "Avis USFans",
  "card.review.desc": "Un aperçu indépendant couvrant la commande, l'entrepôt, le contrôle qualité, l'expédition et l'expérience client globale.",
  "card.shipping.title": "Frais d'expédition USFans",
  "card.shipping.desc": "Comprenez comment le poids, les dimensions, la destination et le mode d'expédition influent sur le coût total.",
  "card.coupon.title": "Coupon USFans",
  "card.coupon.desc": "Apprenez à trouver et vérifier les offres de coupon actuelles avant de les utiliser.",
  "card.discount.title": "Code promo USFans",
  "card.discount.desc": "Comprenez les conditions des codes promo et comment vérifier si une offre est encore valable.",
  "card.warehouse.title": "Entrepôt USFans",
  "card.warehouse.desc": "Découvrez le stockage, le contrôle qualité, la consolidation et la préparation des colis avant l'expédition.",
  "card.legit.title": "USFans est-il fiable ?",
  "card.legit.desc": "Examinez la confiance, la sécurité, le paiement, l'expédition et les facteurs liés au vendeur avant de commander.",

  "articleCta.title": "Lisez notre guide du débutant",
  "articleCta.desc": "Nouveau sur la feuille USFans ? Commencez par notre guide original et complet sur son fonctionnement, le contrôle qualité, les frais d'expédition et la sécurité lors de vos achats.",
  "articleCta.button": "Lire le guide complet",

  "finalCta.title": "Prêt à explorer la feuille USFans ?",
  "finalCta.desc": "Commencez par la feuille, comparez les informations qui comptent et utilisez nos guides avant de décider.",
  "finalCta.button": "Découvrir la feuille USFans",

  "category.shoes": "Chaussures",
  "category.hoodies": "Hoodies / Pulls",
  "category.tshirts": "T-shirts",
  "category.jackets": "Vestes",
  "category.pants": "Pantalons / Shorts",
  "category.headwear": "Couvre-chefs",
  "category.sets": "Ensembles",
  "category.underwear": "Sous-vêtements / Caleçons",
  "category.jersey": "Maillot",
  "category.accessories": "Accessoires",
  "category.bags": "Sacs",
  "category.belts": "Ceintures",
  "category.perfumes": "Parfums",
  "category.other": "Autres articles",

  "pillars.title": "Guides de la feuille USFans",
  "pillars.desc": "Des guides indépendants et détaillés pour comprendre chaque aspect de l'expérience USFans.",
  "pillar.spreadsheet.title": "Guide de la feuille",
  "pillar.spreadsheet.desc": "Ce qu'est la feuille USFans, comment elle fonctionne et comment l'utiliser.",
  "pillar.review.title": "Avis USFans",
  "pillar.review.desc": "Commandes, entrepôt, QC, expédition et expérience client examinés.",
  "pillar.shipping.title": "Frais d'expédition",
  "pillar.shipping.desc": "Comment le poids, les dimensions et le transporteur affectent le coût.",
  "pillar.coupon.title": "Guide des coupons",
  "pillar.coupon.desc": "Comment trouver et vérifier les coupons USFans avant de les utiliser.",
  "pillar.discount.title": "Code promo",
  "pillar.discount.desc": "Validité, conditions et comment appliquer les codes au checkout.",
  "pillar.warehouse.title": "Guide de l'entrepôt",
  "pillar.warehouse.desc": "Stockage, QC, consolidation et préparation des colis.",
  "pillar.legit.title": "USFans est-il fiable?",
  "pillar.legit.desc": "Sécurité, paiements et facteurs de confiance avant de commander.",
  "pillar.qc.title": "Guide QC",
  "pillar.qc.desc": "Comment lire les photos de controle qualité et quoi vérifier.",
  "pillar.beginner.title": "Guide pour débutants",
  "pillar.beginner.desc": "Votre première commande USFans de A à Z.",
  "pillar.safety.title": "Guide de sécurité",
  "pillar.safety.desc": "Précautions essentielles pour protéger votre compte et vos paiements.",

  "readMore": "Lire la suite",
};